import { render, staticRenderFns } from "./GiftBoxCampaignsEditModal.vue?vue&type=template&id=6993c8ed&scoped=true&"
import script from "./GiftBoxCampaignsEditModal.vue?vue&type=script&lang=js&"
export * from "./GiftBoxCampaignsEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6993c8ed",
  null
  
)

export default component.exports